// ═══════════════════════════════════════
// ANALYTICS — Wrapper Matomo trackEvent + usage du répertoire
// ═══════════════════════════════════════

import { currentId, currentUser } from './state.js';

// Événements de l'éditeur aussi enregistrés côté serveur (api/usage.php)
const USAGE_EVENTS = ['play', 'print', 'pdf', 'share'];

/**
 * Envoie un événement Matomo.
 * @param {string} category  — ex. 'Editeur'
 * @param {string} action    — ex. 'play', 'transpose', 'share'
 * @param {string|null} label — ex. slug de la partition (optionnel)
 */
export function trackEvent(category, action, label = null) {
    if (category === 'Editeur' && USAGE_EVENTS.includes(action)) trackUsage(action);

    if (typeof window._paq === 'undefined') return;
    const cmd = ['trackEvent', category, action];
    if (label !== null) cmd.push(label);
    window._paq.push(cmd);
}

/**
 * Enregistre l'usage d'une partition par le compte connecté (consultation,
 * écoute, impression, PDF, partage). Envoi « fire and forget » : n'attend rien
 * et n'échoue jamais visiblement. Ignoré hors connexion ou sans partition.
 * @param {'view'|'play'|'print'|'pdf'|'share'} event
 * @param {number|null} partitionId  par défaut la partition ouverte
 */
export function trackUsage(event, partitionId = currentId) {
    if (!currentUser || !partitionId) return;
    const body = JSON.stringify({ partition_id: partitionId, event });
    try {
        if (navigator.sendBeacon) {
            navigator.sendBeacon('/api/usage.php', new Blob([body], { type: 'application/json' }));
        } else {
            fetch('/api/usage.php', { method: 'POST', body, keepalive: true, credentials: 'same-origin',
                                      headers: { 'Content-Type': 'application/json' } });
        }
    } catch (e) { /* jamais bloquant */ }
}
